<div class="cas-backdrop"></div>
<div class="cas-alert-box">

    <div class="col-md-6">
        <acabim-data-display
                [dataMap]="dataDetail"
                labelAlignment="right"
                labelWidth="9rem"></acabim-data-display>
    </div>

    <div class="col-md-6" *ngIf="(default && title?.includes('Email'))">
            <span>You cannot delete your default email address. If you want to remove this email address, first select another
             email address as your default.</span>
    </div>

    <div class="col-md-6" *ngIf="(default && title?.includes('Email'))">
            <span>A verified email address is required so that we can contact you and grant you access to
                the ACABIM platform</span>
    </div>

    <div class="cas-action-buttons">
        <ng-container *ngIf="(!default && !title?.includes('Email'))">
            <button (click)="onDelete()" class="cas-button-action">Confirm</button>
            <button (click)="onClose()">Cancel</button>
        </ng-container>
        <ng-container *ngIf="(default && title?.includes('Email'))">
            <button (click)="onClose()">Ok</button>
        </ng-container>
    </div>
</div>
